import home from "../../assets/homeAssets/Frame 13.svg";
import "./home.css";

const Home = () => (
  <div id="home" className="home-ultimate-container">
    <div className="home-matter-container">
      <h1 className="home-header">
        Excellence In Education From Class 6 to Class 10
      </h1>
      <p className="home-caption">
        Nurturing young minds with personalized attention, concept clarity, and
        a strong foundation for academic success
      </p>
      <div className="explore-demo-button-container">
        <button className="explore-course-button">Explore Courses</button>
        <a href="tel:+919876543210">
          <button className="free-demo-button">Book Free Demo</button>
        </a>
      </div>
      <div className="home-highlights">
        <div className="highlight-item">
          <h2 className="highlight-head">10+</h2>
          <span className="highlight-text">Years Experience</span>
        </div>
        <div className="highlight-item">
          <h2 className="highlight-head">98%</h2>
          <span className="highlight-text">Success Rate</span>
        </div>
        <div className="highlight-item">
          <h2 className="highlight-head">25+</h2>
          <span className="highlight-text">Expert Faculty</span>
        </div>
      </div>
    </div>
    <div className="home-image-container">
      <img src={home} alt="Students learning" className="home-image" />
    </div>
  </div>
);

export default Home;
